import { formMachine } from '../../../xform';
import cardNumberConfig from './cardNumberConfig';
import cvvConfig from './cvv2Config';
import expirationDateConfig from './expirationDateConfig';
import firstNameConfig from './firstNameConfig';
import lastNameConfig from './lastNameConfig';
const createDCHDebitFormMachine = () => formMachine.withContext({
    // DO NOT CHANGE: the order of these configs must mirror the position of the inputs in the UI for the error focus to work
    fieldConfigs: [
        firstNameConfig(),
        lastNameConfig(),
        cardNumberConfig(),
        expirationDateConfig(),
        cvvConfig()
    ]
});
export default createDCHDebitFormMachine;
